import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import CustomPlayButton from "./CustomPlayButton";
import { useElementInScreen, useDeviceCheck } from "hooks";
import { ITXVideo } from "components/ITXVideo";

export function MediaVideoPlayer({
  id,
  lang,
  video,
  videoMobile,
  videoInfo,
  videoInfoMobile,
  videoInfo4K,
  hideControls,
  showPlay,
  showCustomPlayButton,
  showBigPlayButton,
  aspectRatio,
  useAspectRatio,
  poster,
}) {
  const refVideo = useRef(null);
  const mainComponentRef = useRef(null);
  const { isInViewPort } = useElementInScreen(mainComponentRef);
  const { isMobile } = useDeviceCheck(1024);
  const [videoIsPlaying, setVideoIsPlaying] = useState(false);

  useEffect(() => {
    if (!isInViewPort) {
      setVideoIsPlaying(false);
      refVideo.current.replay();
      if (refVideo.current) {
        refVideo.current.mute(true);
        refVideo.current.seek(0);
      }
    }
  }, [isInViewPort]);

  useEffect(() => {
    if (!useAspectRatio || !isMobile) return;

    const videoElement = document?.querySelector(`.geco-media_player.${id}`);

    if (videoElement && aspectRatio) {
      const ratioParts = aspectRatio.split(":");
      const ratioMultiplier = ratioParts[1] / ratioParts[0];

      // videoElement.style.paddingTop = `${ratioMultiplier * 100}%`;

      const video = videoElement.querySelector("video");
      if (video) {
        //Esta parte del código hace que el ancla
        // no funcione al entrar por segunda vez en sostenibilidad/produccion
        //pero es el que hace que funcione en marcas/pulll&bear
        // video.style.position = "absolute";
        // video.style.top = 0;
        // video.style.left = 0;
        // video.style.width = "100%";
        // video.style.height = "100%";
        // video.style.transition = "none";
        // video.style.objectFit = "contain";
      }
    }
  }, [aspectRatio, id, useAspectRatio, isMobile]);

  return (
    <>
      {!videoIsPlaying && showCustomPlayButton && (
        <CustomPlayButton
          refVideo={refVideo}
          setVideoIsPlaying={setVideoIsPlaying}
          lang={lang}
        />
      )}
      <div ref={mainComponentRef} className="geco-media_player_container">
        <ITXVideo
          source={videoMobile}
          sourceWeb={video}
          source2K={video}
          source4K={video}
          containerClassName={`geco-media_player ${id}`}
          className="geco-media_player__video"
          ref={refVideo}
          muted
          autoPlay
          loop
          actionAnimation={showBigPlayButton || showPlay}
          hideActionBar={
            hideControls || (!videoIsPlaying && showCustomPlayButton)
          }
          locale={lang}
          videoInfo={videoInfo}
          videoInfoMobile={videoInfoMobile}
          videoInfo4K={videoInfo4K}
          useAspectRatio={useAspectRatio}
          poster={poster}
        />
      </div>
    </>
  );
}

MediaVideoPlayer.propTypes = {
  id: PropTypes.string,
  lang: PropTypes.string,
  video: PropTypes.string,
  videoMobile: PropTypes.string,
  hideControls: PropTypes.bool,
  showPlay: PropTypes.bool,
  showBigPlayButton: PropTypes.bool,
  showCustomPlayButton: PropTypes.bool,
  aspectRatio: PropTypes.string,
  useAspectRatio: PropTypes.bool,
  poster: PropTypes.string,
};
